import * as ApolloClient from '@apollo/client';
import * as FeatureHubReact from '@feature-hub/react';
import * as React from 'react';
import * as ReactDom from 'react-dom';
import * as UnifiedWebCommonAlpha from '@oneaudi/unified-web-alpha-common';
import * as UnifiedWebCommonAlphaV2 from '@oneaudi/unified-web-alpha-common-v2';
import * as oneGraphClient from '@oneaudi/onegraph-client';
import * as oneGraphService from '@oneaudi/onegraph-service';
import * as styled from 'styled-components';
export const definedExternals = {
    '@apollo/client': ApolloClient,
    '@feature-hub/react': FeatureHubReact,
    '@oneaudi/onegraph-client': oneGraphClient,
    '@oneaudi/onegraph-service': oneGraphService,
    '@oneaudi/unified-web-alpha-common': UnifiedWebCommonAlpha,
    '@oneaudi/unified-web-alpha-common-v2': UnifiedWebCommonAlphaV2,
    '@volkswagen-onehub/onegraph-client': oneGraphClient,
    react: React,
    'react-dom': ReactDom,
    'styled-components': styled,
};
export const providedExternals = {
    '@apollo/client': process.env.APOLLO_CLIENT_VERSION,
    '@feature-hub/react': process.env.FEATURE_HUB_VERSION,
    '@oneaudi/onegraph-client': process.env.ONEGRAPH_CLIENT_VERSION,
    '@oneaudi/onegraph-service': process.env.SERVICE_ONEGRAPH_SERVICE_VERSION,
    '@oneaudi/unified-web-alpha-common': process.env
        .UNIFIED_WEB_ALPHA_COMMON_VERSION,
    '@oneaudi/unified-web-alpha-common-v2': process.env
        .UNIFIED_WEB_ALPHA_COMMON_V2_VERSION,
    '@volkswagen-onehub/onegraph-client': process.env
        .ONEGRAPH_CLIENT_VERSION,
    react: process.env.REACT_VERSION,
    'react-dom': process.env.REACT_DOM_VERSION,
    'styled-components': process.env.STYLED_COMPONENTS_VERSION,
};
//# sourceMappingURL=alpha.js.map